// Entitlements that unlock Brownlow Genius. An account needs ANY one of these.
// Accounts without one can still sign in but are locked behind the
// coming-soon overlay (see RoleGate/SideNav/BottomNav).
export const ACCESS_ROLES = ['NBA_PRO', 'NBA_ELITE', 'NBA_LIFETIME', 'FREE_TIER'];

// The Snipe JWT carries these tier keys under `subscriptions` (e.g.
// "NBA_ELITE") while feature flags live under `roles`, so check both arrays.
export const hasBrownlowAccess = (user) => {
  if (!user) return false;
  const claims = [...(user.roles || []), ...(user.subscriptions || [])];
  return ACCESS_ROLES.some((key) => claims.includes(key));
};
